import React from 'react';
import { useLocation } from 'react-router-dom';

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => {
    let params = new URLSearchParams(search);
    let queryObj = {};

    for (let [key, value] of params.entries()) {
      // Handle multiple values for the same parameter
      if (queryObj[key]) {
        if (Array.isArray(queryObj[key])) {
          queryObj[key].push(value);
        } else {
          queryObj[key] = [queryObj[key], value];
        }
      } else {
        // Check if the value contains commas (comma-separated values)
        if (value.includes(',')) {
          queryObj[key] = value.split(',').map(v => v.trim());
        } else {
          queryObj[key] = value;
        }
      }
    }

    return queryObj;
  }, [search]);
}

export default useQuery;
